import React, { useEffect,useState } from 'react';
import { useLocation } from 'react-router-dom';
import Toast from './Toast';
const ClearSessionWrapper = ({ children }) => {
  const location = useLocation();
 const [toasts, setToasts] = useState([]);
////////////////////////////
  useEffect(() => {
    const addToast = (message, type) => {
      const id = Date.now() + Math.random();

      setToasts((prev) => [
        ...prev,
        {
          id,
          message,
          type,
        },
      ]);
    };

    window.toast = {
      success: (msg) => addToast(msg, 'success'),
      error: (msg) => addToast(msg, 'error'),
      warning: (msg) => addToast(msg, 'warning'),
      info: (msg) => addToast(msg, 'info'),
      dismissAll: () => setToasts([]),
    };

    return () => {
      window.toast = undefined;
    };
  }, []);

  // Remove individual toast
  const removeToast = (id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };



 //////////////////////////
  useEffect(() => {
    console.log("running", location.pathname);
    if (location.pathname === '/Familydetails') {
        console.log("running inside", location.pathname);
    //   sessionStorage.removeItem("FlatnTower");
    }else if(location.pathname === '/Management'){
        console.log("running inside", location.pathname);
    }else{
        console.log("running Clear", location.pathname);
        sessionStorage.removeItem("FlatnTower");
    }

    if (location.pathname === '/ComplaintDashboard') {
      console.log("running inside", location.pathname);
      localStorage.removeItem("UrgentStats");
        localStorage.removeItem("StatusHelp")
        localStorage.removeItem("TodayStartDate")
        localStorage.removeItem("TodayEndDate")
        localStorage.removeItem("SocietyLevel")
    //   sessionStorage.removeItem("FlatnTower");
    }else if(location.pathname === '/Management'){
        console.log("running inside", location.pathname);
    }else{
        console.log("running Clear", location.pathname);
        // sessionStorage.removeItem("FlatnTower");
        localStorage.removeItem("UrgentStats");
        localStorage.removeItem("StatusHelp")
        localStorage.removeItem("TodayStartDate")
        localStorage.removeItem("TodayEndDate")
        localStorage.removeItem("SocietyLevel")
    }
  }, [location]);

  return <>
   <div
        style={{
          position: "fixed",
          top: "20px",
          right: "20px",
          zIndex: 9999,
          display: "flex",
          flexDirection: "column",
          gap: "8px",
        }}
      >
        {toasts.map((toast) => (
          <Toast
            key={toast.id}
            id={toast.id}
            message={toast.message}
            type={toast.type}
            onClose={removeToast}
          />
        ))}
      </div>
  {children}
  
  </>;
};

export default ClearSessionWrapper;

